<template>
  <ion-page>
    <ion-header :translucent="true">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-button color="primary"></ion-menu-button>
        </ion-buttons>
        <ion-title>Drafts</ion-title>
      </ion-toolbar>
    </ion-header>
    
    <ion-content :fullscreen="true">
      <ion-header collapse="condense">
        <ion-toolbar>
          <ion-title size="large">Drafts</ion-title>
        </ion-toolbar>
      </ion-header>
    
      <div id="container">
        <ion-list>
            <ion-item v-for="(draft,i) of drafts" :key="i">
                <ion-label>
                    <h2>Ship: {{draft.title}}</h2>
                    <h4>Type: {{draft.type==1?"New Client":"Existing Client"}}</h4>
                    <h6><small>{{draft.time}}</small></h6>
                </ion-label>
                <ion-icon @click="editDraft(draft)" class="edit" :ios="createOutline" :md="createOutline"></ion-icon>
                <ion-icon @click="deleteDraft(draft)" class="delete" :ios="closeCircleOutline" :md="closeCircleOutline"></ion-icon>
            </ion-item>
        </ion-list>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonItem, IonList, IonLabel, IonIcon } from '@ionic/vue';
import { closeCircleOutline, createOutline } from 'ionicons/icons';
import localforage from 'localforage';
export default {
  name: 'Drafts',
  components: {
    IonButtons,
    IonContent,
    IonHeader,
    IonMenuButton,
    IonPage,
    IonTitle,
    IonToolbar,
    IonItem,
    IonList,
    IonLabel,
    IonIcon
  },
   created(){
      this.loadData();
  },
  methods:{
      async loadData(){
          const drafts= await localforage.createInstance({
        driver: [
          localforage.INDEXEDDB,
          localforage.LOCALSTORAGE,
        ],
        name:'drafts'
      });
      const ds=[];
      await drafts.iterate((val,key)=>{
          ds.push({
            id:key,
            'sale_id':JSON.parse(val.data)['saleId'],
            title:val.title,
            type:val.type,
            time:new Date(val.time).toDateString(),
          });
      });
      this.drafts=ds;
      },
      editDraft(e){
          if(e.type==1){
              this.$router.push('/client-register/'+e.sale_id+'/'+e.id);
          }else if(e.type==2){
              this.$router.push('/existing-client/'+e.sale_id+'/'+e.id);
          }
      },
      async deleteDraft(d){
        const drafts= await localforage.createInstance({
            driver: [
            localforage.INDEXEDDB,
            localforage.LOCALSTORAGE,
            ],
            name:'drafts'
        });
        drafts.removeItem(d.id);
        this.loadData();
      }
  },
  data(){
      return {
          drafts:[]
      }
  },
  setup(){
      return {
          closeCircleOutline,
          createOutline
      }
  }
}
</script>

<style scoped>
#container {
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  /* top: 50%;
  transform: translateY(-50%); */
}

#container strong {
  font-size: 20px;
  line-height: 26px;
}

#container p {
  font-size: 16px;
  line-height: 22px;
  color: #8c8c8c;
  margin: 0;
}

#container a {
  text-decoration: none;
}
.edit{
    margin-left: 20px;
    color: #3880FF;
}
.delete{
    margin-left: 20px;
    color: #ff2222;
}
</style>